let fakeImg = [{
    'url': 'https://randomuser.me/api/portraits/med/men/33.jpg'
},
{
    'url': 'https://randomuser.me/api/portraits/med/men/1.jpg'
},
{
    'url': 'https://randomuser.me/api/portraits/med/women/78.jpg'
},
{
    'url': 'https://randomuser.me/api/portraits/med/men/75.jpg'
},
{
    'url': 'https://randomuser.me/api/portraits/med/women/21.jpg'
},
{
    'url': 'https://randomuser.me/api/portraits/med/women/59.jpg'
},
{
    'url': 'https://randomuser.me/api/portraits/med/men/31.jpg'
},
{
    'url': 'https://randomuser.me/api/portraits/med/men/91.jpg'
},
{
    'url': 'https://randomuser.me/api/portraits/med/women/27.jpg'
},
{
    'url': 'https://randomuser.me/api/portraits/med/women/76.jpg'
},]

export default fakeImg;